/**
 * Created by claude on 22.07.26.
 * Scene component extracted from Match3Scene
 */

class Match3SceneComponent extends ScriptComponent {
    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);
        this.gameSceneComponent = ComponentMap.get(this.node, GameSceneComponent);

        if (this.gameSceneComponent.level.isDanger() && cleverapps.resolution.mode !== cleverapps.WideMode.HORIZONTAL) {
            this.gameSceneComponent.styling.backgroundId += "_vertical";
        }
    }

    addScoreView() {
        const scoreView = new ScoreView(Game.currentGame.score);
        scoreView.setLocalZOrder(16);
        if (this.gameSceneComponent.infoPanel) {
            this.gameSceneComponent.infoPanel.addChild(scoreView);
        } else {
            this.node.addChild(scoreView);
        }
    }

    addMovesView() {
        const movesView = new MovesView();
        if (movesView) {
            this.movesView = movesView;
            if (this.gameSceneComponent.infoPanel) {
                this.gameSceneComponent.infoPanel.addChild(movesView);
            } else {
                this.node.addChild(movesView);

                Game.currentGame.on("outcome", () => {
                    movesView.hide();
                }, this.node);
            }
        }
    }

    addGoals() {
        this.goalsView = new GoalsView();
        if (this.gameSceneComponent.infoPanel) {
            this.gameSceneComponent.infoPanel.addChild(this.goalsView);
        } else {
            this.node.addChild(this.goalsView);
        }
    }

    addMissions() {
        const game = Game.currentGame;

        if (game.lightingRushMission) {
            const marksView = new LightningRushMarksView();
            if (["riddles", "heroes"].includes(cleverapps.config.name)) {
                this.gameSceneComponent.infoPanel.addChild(marksView);
            } else {
                this.lightningRushMarksControl = new cc.Node();
                this.lightningRushMarksControl.addChild(marksView);
                this.node.addChild(this.lightningRushMarksControl);

                ComponentMap.attach(this.lightningRushMarksControl, new HidingComponent({
                    control: "rewardElementLightningRushMarks"
                }));
            }
        }
    }

    addLevelRewards() {
        if (cleverapps.styles.PassLevelReward.enabled) {
            this.passLevelRewards = new PassLevelReward(this.gameSceneComponent.infoPanel || this.node, this.node);
        }
    }

    addActor() {
        const styles = cleverapps.styles.GameScene.actor;
        if (styles) {
            this.actor = new Actor(styles);
            this.node.addChild(this.actor);
            Game.currentGame.heroAnimation = this.actor.createListener(this.actor.animate.bind(this.actor));
            this.actor.setVisible(false);

            Game.currentGame.on("outcome", () => {
                this.actor.hide();
            }, this.node);
        }
    }

    addBoosters() {
        this.boostersView = new FieldBoostersView(Game.currentGame.boosters);

        if (this.gameSceneComponent.controlsPanel) {
            this.gameSceneComponent.controlsPanel.addChild(this.boostersView);
        } else {
            this.node.addChild(this.boostersView);

            Game.currentGame.on("outcome", () => {
                this.boostersView.hideAnimation();
            }, this.node);
        }
    }

    addDanger() {
        if (this.gameSceneComponent.infoPanel) {
            const dangerComponentView = this.dangerComponentView = new DangerComponentView(Game.currentGame.dangerComponent);

            this.gameSceneComponent.infoPanel.addChild(dangerComponentView);
        }

        this.addWarnings();

        const danger = this.dangerAnimationView = new DangerAnimationView(Game.currentGame.dangerComponent);
        this.node.addChild(danger);
    }

    addWarnings() {
        const leftWarning = new DangerWarningAnimation(DangerWarningAnimation.TYPES.LEFT, Game.currentGame.dangerComponent);
        const rightWarning = new DangerWarningAnimation(DangerWarningAnimation.TYPES.RIGHT, Game.currentGame.dangerComponent);

        this.node.addChild(leftWarning, 100);
        this.node.addChild(rightWarning, 100);
    }

    showDangerButton(outcome, callback) {
        cleverapps.focusManager.display({
            focus: "DangerButtonWindow",
            actions: [
                function (f) {
                    Game.currentGame.dangerComponent.stop();
                    f();
                },
                function (f) {
                    new DangerButtonWindow(outcome);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                },
                function (f) {
                    if (outcome === GameBase.OUTCOME_VICTORY) {
                        this.dangerAnimationView.onWin();
                    } else {
                        this.dangerAnimationView.onLose();
                    }

                    f();
                    callback();
                }.bind(this)
            ]
        });
    }

    onSceneLoaded() {
        const game = Game.currentGame;
        const level = game.level;

        this.addActor();
        this.addGoals();
        this.addMissions();

        const fieldView = this.fieldView = new FieldView(game.field);
        this.node.addChild(fieldView);
        fieldView.adjustSize();

        if (game.hasDanger()) {
            this.addDanger();
        } else {
            this.addMovesView();
            this.addBoosters();

            if (level.isBonus()) {
                this.goalsView.setVisible(false);
            } else {
                this.addScoreView();
            }
        }

        game.onBoosterCellCollected = this.node.createListener(this.showBoosterCellReward.bind(this));

        game.on("lowMoves", (moves) => {
            if (moves === 1 || moves === 2) {
                this.buyMoves();
            } else if (moves === 3 && Game.currentGame.level.isRegular()) {
                HelpByFiveAttemptsWindow.showIfCan();
            } else if (moves === 5) {
                cleverapps.exclamation.show("message.MovesLeft", Exclamation.Types.Warning);
            }
        }, this.node);

        this.addLevelRewards();

        if (Game.currentGame.level.isRegular()) {
            match3.levelAttempts.addAttempt(Game.currentGame.level);
        }
        cleverapps.playSession.inc(cleverapps.EVENTS.PLAY_TIMES);

        if (level.isHard() && cleverapps.styles.HardLevelIcon.enabled) {
            const hardLevelIconParent = cleverapps.styles.HardLevelIcon.parentSceneScene ? this.node : this.gameSceneComponent.infoPanel;
            this.hardLevelIcon = new HardLevelIcon(hardLevelIconParent);
        }

        if (["adventure", "heroes", "runes"].indexOf(cleverapps.config.name) !== -1) {
            fieldView.setVisible(false);
            if (cleverapps.styles.FieldView.slideAnimation.movesView && this.movesView) {
                this.movesView.setVisible(false);
            }
        }

        this.goalsView.views.forEach((target) => {
            target.setVisible(false);
        });

        game.on("showPanels", this.onShowPanels.bind(this), this.node);
        game.on("showActor", this.onShowActor.bind(this), this.node);
        game.on("moveActor", this.onMoveActor.bind(this), this.node);
        game.on("startFilmEffect", this.onStartFilmEffect.bind(this), this.node);
        game.on("stopFilmEffect", this.onStopFilmEffect.bind(this), this.node);
        game.on("outOfMoves", this.outOfMoves.bind(this), this.node);

        this.onResize();
    }

    onReady() {
        const game = Game.currentGame;

        if (!game.hasDanger() && game.level.isBonus()) {
            const bonusLevelView = this.bonusLevelView = new BonusLevelView(game.bonusLevelCounter);
            this.node.addChild(bonusLevelView, -1);
        }
    }

    onShowPanels(silent) {
        if (this.gameSceneComponent.infoPanel) {
            this.gameSceneComponent.infoPanel.show(silent);
        }
        if (this.gameSceneComponent.controlsPanel) {
            this.gameSceneComponent.controlsPanel.show(silent);
        }
    }

    onShowActor(silent) {
        this.actor.showUpAnimation(silent);
    }

    onMoveActor(silent) {
        if (!silent) {
            this.actor.moveAnimation();
        }
    }

    onResize() {
        let styles;

        if (this.actor) {
            styles = cleverapps.styles.GameScene.actor;
            let scaleX = 1, scaleY = 1;
            if (styles.mobileScale && cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
                scaleX = scaleY = styles.mobileScale;
            }
            if (styles.scaleX) {
                scaleX *= styles.scaleX;
            }
            if (styles.scaleY) {
                scaleX *= styles.scaleX;
            }
            cleverapps.timeouts.setTimeout(() => {
                this.actor.setScale(scaleX, scaleY);
            }, 0);
        }

        const infoPanel = this.gameSceneComponent.infoPanel;
        if (infoPanel) {
            infoPanel.setAlignment(infoPanel.getBasePosition());
            infoPanel.onResize();
        }

        if (this.gameSceneComponent.controlsPanel) {
            this.gameSceneComponent.controlsPanel.onResize();
        }
    }

    getHorizontalCenterPartOfScreen() {
        if (!this.gameSceneComponent.level.isDanger()) {
            return;
        }

        const dangerPartOfScreen = this.dangerAnimationView.getPartFromScreen();
        const fieldPartOfScreen = 1 - dangerPartOfScreen;

        return dangerPartOfScreen + fieldPartOfScreen / 2;
    }

    getOverlappingNodes() {
        let overlappingNodes = [ComponentUtils.findComponentByName(this.node, "UpMenuController").node, this.gameSceneComponent.controlsPanel, this.boostersView, this.gameSceneComponent.infoPanel, this.lightningRushMarksControl];

        if (this.bonusLevelView) {
            overlappingNodes = overlappingNodes.concat(this.bonusLevelView.getOverlappingNodes());
        } else {
            overlappingNodes.push(this.goalsView);
        }

        return overlappingNodes.filter(Boolean);
    }

    onAfterResize() {
        const styles = cleverapps.styles.FieldView;
        let padding = styles.padding;

        let centerPoint = cc.p(this.node.width / 2, this.node.height / 2);
        if (this.gameSceneComponent.level.isDanger()) {
            if (cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL) {
                centerPoint.x = this.node.width * this.getHorizontalCenterPartOfScreen();
            } else {
                centerPoint.y = (this.node.height - this.dangerAnimationView.height) / 2;
            }

            padding = styles.danger.padding[cleverapps.resolution.mode];
        }

        const offset = styles.offsets && styles.offsets[cleverapps.resolution.mode];
        if (offset) {
            centerPoint = cc.pAdd(centerPoint, offset);
        }

        cleverapps.UI.inflateToBoundaries(this.fieldView, this.getOverlappingNodes(), {
            centerPoint: this.node.convertToWorldSpace(centerPoint),
            maxScale: 1.5,
            padding
        });
    }

    showBoosterCellReward() {
        if (this.passLevelRewards) {
            this.passLevelRewards.addPrize(PassLevelReward.BOOSTER);
        }
    }

    buyMoves() {
        if (TacticalExtendWindow.canShow()) {
            cleverapps.focusManager.display({
                focus: "TacticalExtendWindow",
                action: function (f) {
                    TacticalExtendWindow.show();

                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        }
    }

    outOfMoves() {
        cleverapps.effects.fire("match3.nomoves");

        cleverapps.focusManager.displayWhenFreeFocus({
            focus: "AddMovesWindow",
            control: "panel_info",
            filter: function () {
                return Game.currentGame && Game.currentGame.outcome === GameBase.OUTCOME_UNKNOWN;
            },
            actions: [
                function (f) {
                    Game.currentGame.counter.setTimeout(f, 500);
                },
                function (f) {
                    new ProlongationWindow(Game.currentGame.prolongation, {
                        onGiveUp: function () {
                            Game.currentGame.lose();
                        }
                    });

                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            ]
        });
    }

    onStartFilmEffect(options) {
        this.sceneComponent.createFilmEffect(options);
    }

    onStopFilmEffect() {
        this.sceneComponent.removeFilmEffect(0.4);
    }
}

Prefab.registerComponent("Match3SceneComponent", Match3SceneComponent);

GameScene = bundles.main.jsons.match3scene_prefab_json;
